import type { ComponentType, FC, MouseEventHandler } from 'react';
import { Switch, type SwitchProps } from 'react-native-paper';

import { ListItem } from '@/features/list/components/ListItem';
import type { AppSwitchProps } from '@/shared/components/AppSwitch.types';

const WebSwitch = Switch as ComponentType<
  SwitchProps & { onClick: MouseEventHandler<HTMLElement> }
>;

export const AppSwitch: FC<AppSwitchProps> = ({
  title,
  value,
  disabled,
  onValueChange,
  icon,
  backgroundColor
}) => (
  <ListItem
    title={title}
    icon={icon}
    arrowIcon={() => (
      <WebSwitch
        value={value}
        disabled={disabled}
        aria-label={title}
        onValueChange={onValueChange}
        onClick={(event) => event.stopPropagation()}
      />
    )}
    onPress={disabled ? undefined : () => onValueChange(!value)}
    backgroundColor={backgroundColor}
  />
);
